<template>
  <div class="category">
    <div class="ly-card">
      <div class="flex m-b-15">
        <el-radio-group v-model="searchFormData.category_type" @change="search">
          <el-radio-button :label="-1">全部</el-radio-button>
          <el-radio-button :label="1">官方</el-radio-button>
          <el-radio-button :label="2">项目</el-radio-button>
        </el-radio-group>
        <div>
          <el-input v-model="searchFormData.category_name" class="search" placeholder="板块名称"></el-input>
          <el-button @click="search" type="primary">查询</el-button>
        </div>
      </div>
      <div>
        <el-button @click="addRow" type="primary">新建</el-button>
        <el-button @click="syncProj">同步项目</el-button>
        <span class="m-l-15"
          >从项目中更新新增加的启用项目，自动创建对应项目板块，原本存在的项目板块被对应项目被禁用或删除后，项目板块仍然存在</span
        >
      </div>
    </div>
    <ly-table
      :getTableData="getTableData"
      :tableHeader="tableHeader"
      :searchFormData="searchFormData"
      class="ly-card"
      ref="lyTable"
    >
      <template v-slot:action="row">
        <el-button @click="editRow(row)" type="text" size="mini">修改</el-button>
        <el-button @click="() => delRow([row.id])" type="text" class="el-button--danger" size="mini">删除</el-button>
        <el-button v-if="!row.activate_status" @click="() => activeRow([row.id])" type="text" size="mini"
          >启用</el-button
        >
        <el-button v-else @click="() => deactiveRow([row.id])" type="text" class="el-button--danger" size="mini"
          >禁用</el-button
        >
      </template>
    </ly-table>
    <el-dialog title="提示" :visible.sync="dialogVisible" width="500px">
      <ly-form :defaultFormItem="defaultFormItem" :formConfig="formConfig" :formKeys="formKeys" ref="lyForm">
        <template v-slot:category_logo="{ formData }">
          <img v-show="formData.category_logo" :src="`${baseUrl}/${formData.category_logo}`" width="100px" />
          <upload
            :action="action"
            @successCBK="value => mediaChange('category_logo', value, formData)"
            accept=".jpg, .jpeg, .png, .gif, .bmp"
          />
        </template>
        <template v-slot:category_cover="{ formData }">
          <img v-show="formData.category_cover" :src="`${baseUrl}/${formData.category_cover}`" width="100px" />
          <upload
            :action="action"
            @successCBK="value => mediaChange('category_cover', value, formData)"
            accept=".jpg, .jpeg, .png, .gif, .bmp"
          />
        </template>
      </ly-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="addSumit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { Dialog, RadioGroup, RadioButton, Input } from 'element-ui';
import LyTable from '@/components/LyTable';
import LyForm from '@/components/LyForm';
import category from '@/api/category';
import cSetting from '@/api/cSetting';
import { categoryTable } from '@/utils/communityHeader';
import { categoryFormItem } from '@/utils/communityFormConfig';
import Upload from '@/components/cUpload';

export default {
  name: 'Category',
  components: {
    LyTable,
    LyForm,
    Upload,
    ElRadioGroup: RadioGroup,
    ElRadioButton: RadioButton,
    ElInput: Input,
    ElDialog: Dialog
  },
  data() {
    return {
      tableHeader: categoryTable,
      action: cSetting.cUpload,
      searchFormData: {
        category_name: '',
        category_type: -1
      },
      getTableData: category.getCategory,
      dialogVisible: false,
      defaultFormItem: {},
      formConfig: {
        'label-width': '100px',
        'label-position': 'left',
        inline: false
      },
      formKeys: categoryFormItem,
      baseUrl: '',
      curItem: {}
    };
  },
  async mounted() {
    this.search();
    this.baseUrl = await this.$store.dispatch('app/getOssUrl');
  },
  methods: {
    search() {
      this.$refs.lyTable.setData();
    },
    editRow(row) {
      this.defaultFormItem = { ...row };
      this.curItem = row;
      this.dialogVisible = true;
    },
    delRow(category_ids) {
      this.$confirm('删除该板块, 是否继续?', '警告', {
        type: 'warning'
      })
        .then(() => {
          category
            .categoryBatchDelete({
              params: {
                category_ids
              }
            })
            .then(res => {
              if (res) {
                this.$message.success(res.msg || '删除成功！');
                this.search();
              }
            });
        })
        .catch(() => {});
    },
    addRow() {
      this.defaultFormItem = {};
      this.curItem = {};
      this.dialogVisible = true;
    },
    async addSumit() {
      const { data, valid } = await this.$refs.lyForm.getFormData();
      if (valid) {
        let res = null;
        if (this.curItem.id) {
          res = await category.editCategory({
            params: data,
            category_id: this.curItem.id
          });
          if (res) {
            this.$message.success(res.msg || '修改成功！');
            this.dialogVisible = false;
            this.search();
          }
        } else {
          res = await category.addCategory({
            params: data
          });
          if (res) {
            this.$message.success(res.msg || '添加成功！');
          }
        }
        if (res) {
          this.dialogVisible = false;
          this.search();
        }
      }
    },
    activeRow(category_ids) {
      category
        .categoryBatchActive({
          params: {
            category_ids
          }
        })
        .then(res => {
          if (res) {
            this.$message.success(res.msg || '启用成功');
            this.search();
          }
        });
    },
    deactiveRow(category_ids) {
      category
        .categoryBatchDeactivate({
          params: {
            category_ids
          }
        })
        .then(res => {
          if (res) {
            this.$message.success(res.msg || '禁用成功');
            this.search();
          }
        });
    },
    syncProj() {},
    mediaChange(key, value, formData) {
      if (value && value.length) {
        // eslint-disable-next-line no-param-reassign
        formData[key] = value[0].url;
      }
    }
  }
};
</script>
<style lang="less">
.category {
  .flex {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .search {
    width: 200px;
    margin-right: 15px;
  }
}
</style>
